import { jsx as x, jsxs as G } from "react/jsx-runtime";
import * as y from "react";
import { useState as Oe, createContext as $t, useContext as qt, useId as Bt, useEffect as ot, useMemo as Lt, Children as Yt, isValidElement as Ht, createElement as Wt } from "react";
import { checkboxBlueprint as Ut, formBlueprint as Gt, formGroupBlueprint as Kt, inputFieldDefaultBlueprint as zt, inputFieldFloatingLabelBlueprint as Jt, radioButtonBlueprint as Xt, radioGroupBlueprint as Zt, selectboxBlueprint as it } from "./index-blueprint.es.js";
import { z as f } from "zod";
import { withManagedProps as J } from "@made-people/managed-props";
import { withZod as X } from "@made-people/react-prop-guard";
import { Field as at, Checkbox as Qt, Label as st, Listbox as en, ListboxButton as tn, ListboxSelectedOption as nn, ListboxOptions as rn, ListboxOption as on } from "@headlessui/react";
import Ve from "clsx";
import { CheckIcon as ut, AngleDownIcon as an } from "@made-people/blueprint-icons";
import { createDiscriminatedSchema as sn } from "@made-people/blueprint-template";
import { useTranslate as je } from "@made-people/grease-translations";
import { PhoneInput as un } from "react-international-phone";
import * as ct from "react-dom";
import "@made-people/blueprint";
const cn = f.object({
  variants: f.custom().optional(),
  checkIcon: f.custom().optional(),
  onChange: f.custom().optional(),
  value: f.custom().optional(),
  label: f.string().optional(),
  checked: f.custom().optional(),
  className: f.string().optional()
}), Wr = J(
  "Checkbox",
  X(
    {
      schema: cn,
      defaultProps: {
        checkIcon: /* @__PURE__ */ x(ut, {})
      }
    },
    ({ variants: e, onChange: t, checkIcon: o, checked: n, label: r, className: i }) => {
      const s = Ut.styles(e), [l, u] = Oe(n), h = (c) => {
        t && t(c), u(!l);
      };
      return /* @__PURE__ */ G(
        at,
        {
          className: Ve(s.base, i),
          onClick: () => h(!l),
          children: [
            /* @__PURE__ */ x(
              Qt,
              {
                checked: n,
                className: s.checkbox,
                onChange: h,
                children: o && n && o
              }
            ),
            r && /* @__PURE__ */ x(st, { className: s.label, children: r })
          ]
        }
      );
    }
  )
), lt = $t({
  form: {},
  setFormField: () => {
  }
}), ln = (e) => {
  const [t, o] = Oe({}), n = {
    form: t,
    setFormField: (r, i) => {
      o((s) => ({ ...s, [r]: i }));
    }
  };
  return /* @__PURE__ */ x(lt.Provider, { value: n, children: e.children });
};
function ft() {
  return qt(lt);
}
const fn = f.object({
  variants: f.custom().optional(),
  className: f.string().optional(),
  children: f.custom().optional()
}), Ur = J(
  "Form",
  X(
    {
      schema: fn,
      defaultProps: {}
    },
    ({ variants: e, className: t, children: o }) => {
      const n = Gt.styles(e);
      return /* @__PURE__ */ x(ln, { children: /* @__PURE__ */ x("div", { className: Ve(n.base, t), children: o }) });
    }
  )
), dn = f.object({
  variants: f.custom().optional(),
  label: f.string().optional(),
  description: f.string().optional(),
  className: f.string().optional(),
  children: f.custom().optional(),
  errorCode: f.string().optional()
}), Gr = J(
  "FormGroup",
  X(
    {
      schema: dn,
      defaultProps: {}
    },
    ({ variants: e, label: t, description: o, className: n, errorCode: r, children: i }) => {
      const s = Kt.styles(e), u = r ? {
        INVALID_EMAIL: "Form_InvalidEmail",
        EMPTY_FORM: "Form_EmptyForm"
      }[r] || r : null;
      return /* @__PURE__ */ G("div", { className: Ve(s.base, n), children: [
        t && /* @__PURE__ */ x("label", { className: s.label, children: t }),
        /* @__PURE__ */ x("div", { className: s.fieldWrapper, children: i }),
        o || u && /* @__PURE__ */ x("p", { className: s.description, children: o || u })
      ] });
    }
  )
), dt = f.object({
  label: f.string().optional(),
  id: f.string().optional(),
  onChange: f.custom().optional(),
  onKeyDown: f.custom().optional(),
  helperText: f.object({
    text: f.string(),
    type: f.enum(["error", "warning", "info"])
  }).optional(),
  type: f.enum(["text", "email", "password", "number", "tel", "url", "date"]).optional(),
  disabled: f.boolean().optional(),
  className: f.string().optional(),
  placeholder: f.string().optional(),
  value: f.string().optional(),
  ariaLabel: f.string().optional(),
  required: f.boolean().optional(),
  name: f.string().optional(),
  autoComplete: f.string().optional(),
  pattern: f.string().optional(),
  inputMode: f.enum([
    "none",
    "text",
    "tel",
    "url",
    "email",
    "numeric",
    "decimal",
    "search"
  ]).optional(),
  maxLength: f.object({
    enabled: f.boolean().optional(),
    length: f.number().optional()
  }).optional(),
  min: f.string().optional(),
  max: f.string().optional()
}), pt = f.object({
  variants: f.custom().optional()
}).merge(dt), pn = J(
  "InputFieldDefault",
  X(
    {
      schema: pt,
      defaultProps: {
        type: "text",
        variants: {
          size: {
            initial: "sm",
            lg: "md"
          }
        },
        maxLength: {
          enabled: !1
        }
      }
    },
    ({
      label: e,
      helperText: t,
      disabled: o,
      className: n,
      placeholder: r,
      id: i,
      required: s,
      variants: l,
      onChange: u,
      onKeyDown: h,
      type: c,
      maxLength: a,
      min: d,
      max: g,
      ...C
    }) => {
      var b;
      const T = zt.styles(l), O = je(), S = Bt(), D = i || S, I = typeof r == "string" ? O(r) : r;
      return /* @__PURE__ */ x(
        "input",
        {
          type: c,
          id: D,
          className: T.input,
          placeholder: I,
          onChange: u,
          onKeyDown: h,
          disabled: o,
          required: s,
          "data-has-value": (((b = C.value) == null ? void 0 : b.length) ?? 0) > 0 ? "true" : "false",
          ...C,
          maxLength: a != null && a.enabled ? a == null ? void 0 : a.length : void 0,
          min: d,
          max: g
        }
      );
    }
  )
), mt = f.object({
  variants: f.custom().optional()
}).merge(dt), mn = J(
  "InputFieldFloatingLabel",
  X(
    mt,
    ({
      label: e,
      helperText: t,
      disabled: o,
      className: n,
      placeholder: r,
      id: i,
      required: s,
      variants: l,
      onChange: u,
      maxLength: h,
      onKeyDown: c,
      min: a,
      max: d,
      ...g
    }) => {
      var D;
      const C = Jt.styles(l), T = je(), O = typeof r == "string" ? T(r) : r, S = typeof e == "string" ? T(e) : e;
      return /* @__PURE__ */ G("div", { className: C.base, children: [
        /* @__PURE__ */ G("div", { className: C.inputWrapper, children: [
          /* @__PURE__ */ x(
            "input",
            {
              type: g.type ?? "text",
              id: i,
              className: C.input,
              placeholder: e ? O : "",
              onChange: u,
              onKeyDown: c,
              disabled: o,
              required: s,
              "data-has-value": (((D = g.value) == null ? void 0 : D.length) ?? 0) > 0 ? "true" : "false",
              ...g,
              maxLength: h != null && h.enabled ? h == null ? void 0 : h.length : void 0,
              min: a,
              max: d
            }
          ),
          (S || O) && /* @__PURE__ */ x("label", { htmlFor: i, className: C.label, children: S ?? O })
        ] }),
        t && /* @__PURE__ */ x("p", { className: C.helperText, "data-is-type": t.type, children: t.text })
      ] });
    }
  )
), ht = {
  simple: {
    schema: pt,
    Component: pn,
    isDefault: !0
  },
  "floating-label": {
    schema: mt,
    Component: mn
  }
}, hn = sn(ht), Kr = J(
  "InputField",
  X(hn, (e) => {
    const { setFormField: t } = ft(), [o, n] = Oe("");
    ot(() => {
      e.value && n(e.value);
    }, [e.value]);
    const r = (l) => {
      var u;
      n(l.target.value), e.id && t(e.id, l.target.value), (u = e.onChange) == null || u.call(e, l);
    }, i = e.template, { Component: s } = ht[i];
    return /* @__PURE__ */ x(s, { ...e, onChange: r, value: o });
  })
), yn = f.object({
  id: f.string().optional(),
  value: f.string().optional(),
  onChange: f.function().args(f.string()).optional(),
  defaultCountry: f.string().optional(),
  placeholder: f.string().optional(),
  disabled: f.boolean().optional(),
  required: f.boolean().optional(),
  "aria-required": f.boolean().optional(),
  name: f.string().optional(),
  className: f.string().optional(),
  forceDialCode: f.boolean().optional(),
  inputProps: f.record(f.any()).optional()
}), zr = J(
  "PhoneNumberField",
  X(
    {
      schema: yn,
      defaultProps: {
        defaultCountry: "se",
        placeholder: "Enter phone number",
        required: !0,
        "aria-required": !0,
        name: "phoneNumber",
        forceDialCode: !0,
        inputProps: {
          minLength: 6,
          autoComplete: "tel"
        }
      }
    },
    (e) => {
      const { setFormField: t } = ft(), [o, n] = Oe(e.value || "");
      ot(() => {
        e.value !== void 0 && n(e.value);
      }, [e.value]);
      const r = (i) => {
        var s;
        n(i), e.id && t(e.id, i), (s = e.onChange) == null || s.call(e, i);
      };
      return /* @__PURE__ */ x(
        un,
        {
          defaultCountry: e.defaultCountry,
          value: o,
          inputProps: {
            name: e.name,
            "aria-required": e["aria-required"],
            required: e.required,
            ...e.inputProps
          },
          forceDialCode: e.forceDialCode,
          className: e.className,
          placeholder: e.placeholder,
          onChange: r,
          disabled: e.disabled
        }
      );
    }
  )
);
function gn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Fe = { exports: {} }, ve = { exports: {} }, V = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function vn() {
  if (We)
    return V;
  We = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, a = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, T = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function I(m) {
    if (typeof m == "object" && m !== null) {
      var L = m.$$typeof;
      switch (L) {
        case t:
          switch (m = m.type, m) {
            case u:
            case h:
            case n:
            case i:
            case r:
            case a:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case l:
                case c:
                case C:
                case g:
                case s:
                  return m;
                default:
                  return L;
              }
          }
        case o:
          return L;
      }
    }
  }
  function b(m) {
    return I(m) === h;
  }
  return V.AsyncMode = u, V.ConcurrentMode = h, V.ContextConsumer = l, V.ContextProvider = s, V.Element = t, V.ForwardRef = c, V.Fragment = n, V.Lazy = C, V.Memo = g, V.Portal = o, V.Profiler = i, V.StrictMode = r, V.Suspense = a, V.isAsyncMode = function(m) {
    return b(m) || I(m) === u;
  }, V.isConcurrentMode = b, V.isContextConsumer = function(m) {
    return I(m) === l;
  }, V.isContextProvider = function(m) {
    return I(m) === s;
  }, V.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === t;
  }, V.isForwardRef = function(m) {
    return I(m) === c;
  }, V.isFragment = function(m) {
    return I(m) === n;
  }, V.isLazy = function(m) {
    return I(m) === C;
  }, V.isMemo = function(m) {
    return I(m) === g;
  }, V.isPortal = function(m) {
    return I(m) === o;
  }, V.isProfiler = function(m) {
    return I(m) === i;
  }, V.isStrictMode = function(m) {
    return I(m) === r;
  }, V.isSuspense = function(m) {
    return I(m) === a;
  }, V.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === h || m === i || m === r || m === a || m === d || typeof m == "object" && m !== null && (m.$$typeof === C || m.$$typeof === g || m.$$typeof === s || m.$$typeof === l || m.$$typeof === c || m.$$typeof === O || m.$$typeof === S || m.$$typeof === D || m.$$typeof === T);
  }, V.typeOf = I, V;
}
var j = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ue;
function bn() {
  return Ue || (Ue = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, a = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, T = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
    function I(E) {
      return typeof E == "string" || typeof E == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      E === n || E === h || E === i || E === r || E === a || E === d || typeof E == "object" && E !== null && (E.$$typeof === C || E.$$typeof === g || E.$$typeof === s || E.$$typeof === l || E.$$typeof === c || E.$$typeof === O || E.$$typeof === S || E.$$typeof === D || E.$$typeof === T);
    }
    function b(E) {
      if (typeof E == "object" && E !== null) {
        var Q = E.$$typeof;
        switch (Q) {
          case t:
            var ge = E.type;
            switch (ge) {
              case u:
              case h:
              case n:
              case i:
              case r:
              case a:
                return ge;
              default:
                var He = ge && ge.$$typeof;
                switch (He) {
                  case l:
                  case c:
                  case C:
                  case g:
                  case s:
                    return He;
                  default:
                    return Q;
                }
            }
          case o:
            return Q;
        }
      }
    }
    var m = u, L = h, q = l, Z = s, U = t, K = c, B = n, ie = C, ae = g, te = o, ue = i, H = r, z = a, ce = !1;
    function ne(E) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), p(E) || b(E) === u;
    }
    function p(E) {
      return b(E) === h;
    }
    function R(E) {
      return b(E) === l;
    }
    function _(E) {
      return b(E) === s;
    }
    function w(E) {
      return typeof E == "object" && E !== null && E.$$typeof === t;
    }
    function P(E) {
      return b(E) === c;
    }
    function A(E) {
      return b(E) === n;
    }
    function N(E) {
      return b(E) === C;
    }
    function M(E) {
      return b(E) === g;
    }
    function k(E) {
      return b(E) === o;
    }
    function $(E) {
      return b(E) === i;
    }
    function F(E) {
      return b(E) === r;
    }
    function Y(E) {
      return b(E) === a;
    }
    j.AsyncMode = m, j.ConcurrentMode = L, j.ContextConsumer = q, j.ContextProvider = Z, j.Element = U, j.ForwardRef = K, j.Fragment = B, j.Lazy = ie, j.Memo = ae, j.Portal = te, j.Profiler = ue, j.StrictMode = H, j.Suspense = z, j.isAsyncMode = ne, j.isConcurrentMode = p, j.isContextConsumer = R, j.isContextProvider = _, j.isElement = w, j.isForwardRef = P, j.isFragment = A, j.isLazy = N, j.isMemo = M, j.isPortal = k, j.isProfiler = $, j.isStrictMode = F, j.isSuspense = Y, j.isValidElementType = I, j.typeOf = b;
  }()), j;
}
var Ge;
function yt() {
  return Ge || (Ge = 1, process.env.NODE_ENV === "production" ? ve.exports = vn() : ve.exports = bn()), ve.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var we, Ke;
function En() {
  if (Ke)
    return we;
  Ke = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, l = 0; l < 10; l++)
        s["_" + String.fromCharCode(l)] = l;
      var u = Object.getOwnPropertyNames(s).map(function(c) {
        return s[c];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var h = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        h[c] = c;
      }), Object.keys(Object.assign({}, h)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return we = r() ? Object.assign : function(i, s) {
    for (var l, u = n(i), h, c = 1; c < arguments.length; c++) {
      l = Object(arguments[c]);
      for (var a in l)
        t.call(l, a) && (u[a] = l[a]);
      if (e) {
        h = e(l);
        for (var d = 0; d < h.length; d++)
          o.call(l, h[d]) && (u[h[d]] = l[h[d]]);
      }
    }
    return u;
  }, we;
}
var Ie, ze;
function $e() {
  if (ze)
    return Ie;
  ze = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ie = e, Ie;
}
var _e, Je;
function gt() {
  return Je || (Je = 1, _e = Function.call.bind(Object.prototype.hasOwnProperty)), _e;
}
var Ne, Xe;
function Cn() {
  if (Xe)
    return Ne;
  Xe = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = $e(), o = {}, n = gt();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function r(i, s, l, u, h) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i)
        if (n(i, c)) {
          var a;
          try {
            if (typeof i[c] != "function") {
              var d = Error(
                (u || "React class") + ": " + l + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            a = i[c](s, c, u, l, null, t);
          } catch (C) {
            a = C;
          }
          if (a && !(a instanceof Error) && e(
            (u || "React class") + ": type specification of " + l + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof a + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), a instanceof Error && !(a.message in o)) {
            o[a.message] = !0;
            var g = h ? h() : "";
            e(
              "Failed " + l + " type: " + a.message + (g ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, Ne = r, Ne;
}
var Me, Ze;
function Rn() {
  if (Ze)
    return Me;
  Ze = 1;
  var e = yt(), t = En(), o = $e(), n = gt(), r = Cn(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var u = "Warning: " + l;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Me = function(l, u) {
    var h = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function a(p) {
      var R = p && (h && p[h] || p[c]);
      if (typeof R == "function")
        return R;
    }
    var d = "<<anonymous>>", g = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: D(),
      arrayOf: I,
      element: b(),
      elementType: m(),
      instanceOf: L,
      node: K(),
      objectOf: Z,
      oneOf: q,
      oneOfType: U,
      shape: ie,
      exact: ae
    };
    function C(p, R) {
      return p === R ? p !== 0 || 1 / p === 1 / R : p !== p && R !== R;
    }
    function T(p, R) {
      this.message = p, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
    }
    T.prototype = Error.prototype;
    function O(p) {
      if (process.env.NODE_ENV !== "production")
        var R = {}, _ = 0;
      function w(A, N, M, k, $, F, Y) {
        if (k = k || d, F = F || M, Y !== o) {
          if (u) {
            var E = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw E.name = "Invariant Violation", E;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Q = k + ":" + M;
            !R[Q] && // Avoid spamming the console because they are often not actionable except for lib authors
            _ < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + F + "` prop on `" + k + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), R[Q] = !0, _++);
          }
        }
        return N[M] == null ? A ? N[M] === null ? new T("The " + $ + " `" + F + "` is marked as required " + ("in `" + k + "`, but its value is `null`.")) : new T("The " + $ + " `" + F + "` is marked as required in " + ("`" + k + "`, but its value is `undefined`.")) : null : p(N, M, k, $, F);
      }
      var P = w.bind(null, !1);
      return P.isRequired = w.bind(null, !0), P;
    }
    function S(p) {
      function R(_, w, P, A, N, M) {
        var k = _[w], $ = H(k);
        if ($ !== p) {
          var F = z(k);
          return new T(
            "Invalid " + A + " `" + N + "` of type " + ("`" + F + "` supplied to `" + P + "`, expected ") + ("`" + p + "`."),
            { expectedType: p }
          );
        }
        return null;
      }
      return O(R);
    }
    function D() {
      return O(s);
    }
    function I(p) {
      function R(_, w, P, A, N) {
        if (typeof p != "function")
          return new T("Property `" + N + "` of component `" + P + "` has invalid PropType notation inside arrayOf.");
        var M = _[w];
        if (!Array.isArray(M)) {
          var k = H(M);
          return new T("Invalid " + A + " `" + N + "` of type " + ("`" + k + "` supplied to `" + P + "`, expected an array."));
        }
        for (var $ = 0; $ < M.length; $++) {
          var F = p(M, $, P, A, N + "[" + $ + "]", o);
          if (F instanceof Error)
            return F;
        }
        return null;
      }
      return O(R);
    }
    function b() {
      function p(R, _, w, P, A) {
        var N = R[_];
        if (!l(N)) {
          var M = H(N);
          return new T("Invalid " + P + " `" + A + "` of type " + ("`" + M + "` supplied to `" + w + "`, expected a single ReactElement."));
        }
        return null;
      }
      return O(p);
    }
    function m() {
      function p(R, _, w, P, A) {
        var N = R[_];
        if (!e.isValidElementType(N)) {
          var M = H(N);
          return new T("Invalid " + P + " `" + A + "` of type " + ("`" + M + "` supplied to `" + w + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return O(p);
    }
    function L(p) {
      function R(_, w, P, A, N) {
        if (!(_[w] instanceof p)) {
          var M = p.name || d, k = ne(_[w]);
          return new T("Invalid " + A + " `" + N + "` of type " + ("`" + k + "` supplied to `" + P + "`, expected ") + ("instance of `" + M + "`."));
        }
        return null;
      }
      return O(R);
    }
    function q(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function R(_, w, P, A, N) {
        for (var M = _[w], k = 0; k < p.length; k++)
          if (C(M, p[k]))
            return null;
        var $ = JSON.stringify(p, function(Y, E) {
          var Q = z(E);
          return Q === "symbol" ? String(E) : E;
        });
        return new T("Invalid " + A + " `" + N + "` of value `" + String(M) + "` " + ("supplied to `" + P + "`, expected one of " + $ + "."));
      }
      return O(R);
    }
    function Z(p) {
      function R(_, w, P, A, N) {
        if (typeof p != "function")
          return new T("Property `" + N + "` of component `" + P + "` has invalid PropType notation inside objectOf.");
        var M = _[w], k = H(M);
        if (k !== "object")
          return new T("Invalid " + A + " `" + N + "` of type " + ("`" + k + "` supplied to `" + P + "`, expected an object."));
        for (var $ in M)
          if (n(M, $)) {
            var F = p(M, $, P, A, N + "." + $, o);
            if (F instanceof Error)
              return F;
          }
        return null;
      }
      return O(R);
    }
    function U(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var R = 0; R < p.length; R++) {
        var _ = p[R];
        if (typeof _ != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ce(_) + " at index " + R + "."
          ), s;
      }
      function w(P, A, N, M, k) {
        for (var $ = [], F = 0; F < p.length; F++) {
          var Y = p[F], E = Y(P, A, N, M, k, o);
          if (E == null)
            return null;
          E.data && n(E.data, "expectedType") && $.push(E.data.expectedType);
        }
        var Q = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new T("Invalid " + M + " `" + k + "` supplied to " + ("`" + N + "`" + Q + "."));
      }
      return O(w);
    }
    function K() {
      function p(R, _, w, P, A) {
        return te(R[_]) ? null : new T("Invalid " + P + " `" + A + "` supplied to " + ("`" + w + "`, expected a ReactNode."));
      }
      return O(p);
    }
    function B(p, R, _, w, P) {
      return new T(
        (p || "React class") + ": " + R + " type `" + _ + "." + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + P + "`."
      );
    }
    function ie(p) {
      function R(_, w, P, A, N) {
        var M = _[w], k = H(M);
        if (k !== "object")
          return new T("Invalid " + A + " `" + N + "` of type `" + k + "` " + ("supplied to `" + P + "`, expected `object`."));
        for (var $ in p) {
          var F = p[$];
          if (typeof F != "function")
            return B(P, A, N, $, z(F));
          var Y = F(M, $, P, A, N + "." + $, o);
          if (Y)
            return Y;
        }
        return null;
      }
      return O(R);
    }
    function ae(p) {
      function R(_, w, P, A, N) {
        var M = _[w], k = H(M);
        if (k !== "object")
          return new T("Invalid " + A + " `" + N + "` of type `" + k + "` " + ("supplied to `" + P + "`, expected `object`."));
        var $ = t({}, _[w], p);
        for (var F in $) {
          var Y = p[F];
          if (n(p, F) && typeof Y != "function")
            return B(P, A, N, F, z(Y));
          if (!Y)
            return new T(
              "Invalid " + A + " `" + N + "` key `" + F + "` supplied to `" + P + "`.\nBad object: " + JSON.stringify(_[w], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(p), null, "  ")
            );
          var E = Y(M, F, P, A, N + "." + F, o);
          if (E)
            return E;
        }
        return null;
      }
      return O(R);
    }
    function te(p) {
      switch (typeof p) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !p;
        case "object":
          if (Array.isArray(p))
            return p.every(te);
          if (p === null || l(p))
            return !0;
          var R = a(p);
          if (R) {
            var _ = R.call(p), w;
            if (R !== p.entries) {
              for (; !(w = _.next()).done; )
                if (!te(w.value))
                  return !1;
            } else
              for (; !(w = _.next()).done; ) {
                var P = w.value;
                if (P && !te(P[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ue(p, R) {
      return p === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
    }
    function H(p) {
      var R = typeof p;
      return Array.isArray(p) ? "array" : p instanceof RegExp ? "object" : ue(R, p) ? "symbol" : R;
    }
    function z(p) {
      if (typeof p > "u" || p === null)
        return "" + p;
      var R = H(p);
      if (R === "object") {
        if (p instanceof Date)
          return "date";
        if (p instanceof RegExp)
          return "regexp";
      }
      return R;
    }
    function ce(p) {
      var R = z(p);
      switch (R) {
        case "array":
        case "object":
          return "an " + R;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + R;
        default:
          return R;
      }
    }
    function ne(p) {
      return !p.constructor || !p.constructor.name ? d : p.constructor.name;
    }
    return g.checkPropTypes = r, g.resetWarningCache = r.resetWarningCache, g.PropTypes = g, g;
  }, Me;
}
var Ae, Qe;
function Tn() {
  if (Qe)
    return Ae;
  Qe = 1;
  var e = $e();
  function t() {
  }
  function o() {
  }
  return o.resetWarningCache = t, Ae = function() {
    function n(s, l, u, h, c, a) {
      if (a !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function r() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: r,
      element: n,
      elementType: n,
      instanceOf: r,
      node: n,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: o,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Ae;
}
if (process.env.NODE_ENV !== "production") {
  var On = yt(), Sn = !0;
  Fe.exports = Rn()(On.isElement, Sn);
} else
  Fe.exports = Tn()();
var xn = Fe.exports;
const v = /* @__PURE__ */ gn(xn);
function Pn(e, t) {
  let o = {};
  return Object.entries(e).forEach(([n, r]) => {
    if (t != null && t.hasOwnProperty(n)) {
      const i = t[n](r);
      i != null && (o = {
        ...o,
        ...i
      });
      return;
    }
    r === !0 ? o[`data-${n.toLowerCase()}`] = "" : r && (o[`data-${n.toLowerCase()}`] = r.toString());
  }), o;
}
function wn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function oe(e, ...t) {
  let o = t[0];
  for (let n = 1; n < t.length; n += 1)
    o = et(o, t[n]);
  return et(e, o);
}
function et(e, t) {
  return e ? Object.entries(e).reduce((o, [n, r]) => (// This approach is more efficient than using a regex.
  n[0] === "o" && n[1] === "n" && n.charCodeAt(2) >= 65 && n.charCodeAt(2) <= 90 && typeof r == "function" ? o[n] = (i) => {
    let s = !1;
    const l = r, u = t[n], h = i;
    h.preventBaseUIHandler = () => {
      s = !0;
    };
    const c = l(h);
    return s || u == null || u(h), c;
  } : n === "style" ? (r || t.style) && (o[n] = {
    ...t.style,
    ...r || {}
  }) : n === "className" ? r ? t.className ? o[n] = r + " " + t.className : o[n] = r : o[n] = t.className : o[n] = r, o), {
    ...t
  }) : t;
}
function In(e, t, o) {
  return typeof e == "function" ? e(t, o) : /* @__PURE__ */ y.cloneElement(e, {
    ...oe(e.props, t),
    ref: t.ref
  });
}
function Se(...e) {
  return y.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((o) => {
      _n(o, t);
    });
  }, e);
}
function _n(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const Nn = parseInt(y.version, 10);
function Mn(e) {
  return Nn >= e;
}
function An(e, ...t) {
  let o;
  return typeof e != "function" ? o = Mn(19) ? e.props.ref : e.ref : o = null, Se(o, ...t);
}
const Dn = {
  button: (e) => /* @__PURE__ */ x("button", {
    type: "button",
    ...e
  }),
  div: (e) => /* @__PURE__ */ x("div", {
    ...e
  }),
  h2: (e) => /* @__PURE__ */ x("h2", {
    ...e
  }),
  h3: (e) => /* @__PURE__ */ x("h3", {
    ...e
  }),
  output: (e) => /* @__PURE__ */ x("output", {
    ...e
  }),
  p: (e) => /* @__PURE__ */ x("p", {
    ...e
  }),
  span: (e) => /* @__PURE__ */ x("span", {
    ...e
  }),
  a: (e) => /* @__PURE__ */ x("a", {
    ...e
  }),
  label: (e) => /* @__PURE__ */ x("label", {
    ...e
  }),
  input: (e) => /* @__PURE__ */ x("input", {
    ...e
  }),
  fieldset: (e) => /* @__PURE__ */ x("fieldset", {
    ...e
  }),
  form: (e) => /* @__PURE__ */ x("form", {
    ...e
  }),
  img: (e) => /* @__PURE__ */ x("img", {
    alt: "",
    ...e
  })
};
function ye(e) {
  const {
    render: t,
    className: o,
    state: n,
    ref: r,
    propGetter: i = (T) => T,
    extraProps: s,
    customStyleHookMapping: l
  } = e, u = wn(o, n), c = {
    ...y.useMemo(() => Pn(n, l), [n, l]),
    ...s
  };
  let a;
  typeof t == "string" ? a = Dn[t] : a = t;
  const d = i(c), g = {
    ...d,
    ref: An(a, r, d.ref)
  };
  return u !== void 0 && (g.className = u), {
    renderElement: () => In(a, g, n)
  };
}
const Ce = () => {
}, qe = /* @__PURE__ */ y.createContext({
  disabled: void 0,
  readOnly: void 0,
  required: void 0,
  checkedValue: "",
  setCheckedValue: Ce,
  onValueChange: Ce,
  touched: !1,
  setTouched: Ce
});
process.env.NODE_ENV !== "production" && (qe.displayName = "RadioGroupContext");
function vt() {
  return y.useContext(qe);
}
const kn = {
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "fixed",
  top: 0,
  left: 0,
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
};
let tt = /* @__PURE__ */ function(e) {
  return e.disabled = "data-disabled", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({});
const bt = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, Et = {
  valid(e) {
    return e === null ? null : e ? {
      [tt.valid]: ""
    } : {
      [tt.invalid]: ""
    };
  }
}, re = () => {
}, Ct = /* @__PURE__ */ y.createContext({
  invalid: void 0,
  controlId: void 0,
  setControlId: re,
  labelId: void 0,
  setLabelId: re,
  messageIds: [],
  setMessageIds: re,
  name: void 0,
  validityData: {
    state: bt,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: re,
  disabled: void 0,
  touched: !1,
  setTouched: re,
  dirty: !1,
  setDirty: re,
  filled: !1,
  setFilled: re,
  focused: !1,
  setFocused: re,
  validate: () => null,
  validationMode: "onBlur",
  validationDebounceTime: 0,
  state: {
    disabled: !1,
    valid: null,
    touched: !1,
    dirty: !1,
    filled: !1,
    focused: !1
  },
  markedDirtyRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (Ct.displayName = "FieldRootContext");
function pe(e = !0) {
  const t = y.useContext(Ct);
  if (t.setControlId === re && !e)
    throw new Error("Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>.");
  return t;
}
const ee = typeof window < "u" ? y.useLayoutEffect : y.useEffect;
function Fn(e) {
  const {
    disabled: t,
    readOnly: o,
    value: n,
    required: r
  } = e, {
    checkedValue: i,
    setCheckedValue: s,
    onValueChange: l,
    touched: u,
    setTouched: h,
    fieldControlValidation: c
  } = vt(), {
    setDirty: a,
    validityData: d,
    setTouched: g,
    setFilled: C,
    validationMode: T
  } = pe(), O = i === n, S = y.useRef(null);
  ee(() => {
    var b;
    (b = S.current) != null && b.checked && C(!0);
  }, [C]);
  const D = y.useCallback((b) => oe(c ? c.getValidationProps(b) : b, {
    role: "radio",
    type: "button",
    "aria-checked": O,
    "aria-required": r || void 0,
    "aria-disabled": t || void 0,
    "aria-readonly": o || void 0,
    disabled: t,
    onKeyDown(m) {
      m.key === "Enter" && m.preventDefault();
    },
    onClick(m) {
      var L;
      m.defaultPrevented || t || o || (m.preventDefault(), (L = S.current) == null || L.click());
    },
    onFocus(m) {
      var L;
      m.defaultPrevented || t || o || !u || ((L = S.current) == null || L.click(), h(!1));
    }
  }), [c, O, r, t, o, u, h]), I = y.useCallback((b) => oe(b, {
    type: "radio",
    ref: S,
    tabIndex: -1,
    style: kn,
    "aria-hidden": !0,
    disabled: t,
    checked: O,
    required: r,
    readOnly: o,
    onChange(m) {
      m.nativeEvent.defaultPrevented || t || o || n == null || (g(!0), a(n !== d.initialValue), s(n), C(!0), l == null || l(n, m.nativeEvent), T === "onChange" && (c == null || c.commitValidation(n)));
    }
  }), [t, O, r, o, n, g, a, d.initialValue, s, C, l, T, c]);
  return y.useMemo(() => ({
    checked: O,
    getRootProps: D,
    getInputProps: I
  }), [O, D, I]);
}
const Be = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (Be.displayName = "RadioRootContext");
function Vn() {
  const e = y.useContext(Be);
  if (e === void 0)
    throw new Error("Base UI: RadioRootContext is missing. Radio parts must be placed within <Radio.Root>.");
  return e;
}
const Le = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (Le.displayName = "CompositeRootContext");
function Rt() {
  const e = y.useContext(Le);
  if (e === void 0)
    throw new Error("Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>.");
  return e;
}
const Ye = /* @__PURE__ */ y.createContext({
  register: () => {
  },
  unregister: () => {
  },
  map: /* @__PURE__ */ new Map(),
  elementsRef: {
    current: []
  }
});
process.env.NODE_ENV !== "production" && (Ye.displayName = "CompositeListContext");
function jn() {
  return y.useContext(Ye);
}
function $n(e = {}) {
  const {
    label: t,
    metadata: o
  } = e, {
    register: n,
    unregister: r,
    map: i,
    elementsRef: s,
    labelsRef: l
  } = jn(), [u, h] = y.useState(null), c = y.useRef(null), a = y.useCallback((d) => {
    if (c.current = d, u !== null && (s.current[u] = d, l)) {
      const g = t !== void 0;
      l.current[u] = g ? t : (d == null ? void 0 : d.textContent) ?? null;
    }
  }, [u, s, l, t]);
  return ee(() => {
    const d = c.current;
    if (d)
      return n(d, o), () => {
        r(d);
      };
  }, [n, r, o]), ee(() => {
    var g;
    const d = c.current ? (g = i.get(c.current)) == null ? void 0 : g.index : null;
    d != null && h(d);
  }, [i]), y.useMemo(() => ({
    ref: a,
    index: u ?? -1
  }), [u, a]);
}
function qn(e = {}) {
  const {
    highlightedIndex: t,
    onHighlightedIndexChange: o
  } = Rt(), {
    ref: n,
    index: r
  } = $n(e), i = t === r, s = y.useCallback((l = {}) => oe(l, {
    tabIndex: i ? 0 : -1,
    onFocus() {
      o(r);
    }
  }), [i, r, o]);
  return y.useMemo(() => ({
    getItemProps: s,
    ref: n,
    index: r
  }), [s, n, r]);
}
const Tt = v.oneOfType([v.func, v.object]);
function Ot(e) {
  const {
    render: t,
    className: o,
    itemRef: n,
    metadata: r,
    ...i
  } = e, {
    highlightedIndex: s
  } = Rt(), {
    getItemProps: l,
    ref: u,
    index: h
  } = qn({
    metadata: r
  }), c = y.useMemo(() => ({
    highlighted: h === s
  }), [h, s]), a = Se(n, u), {
    renderElement: d
  } = ye({
    propGetter: l,
    ref: a,
    render: t ?? "div",
    state: c,
    className: o,
    extraProps: i
  });
  return d();
}
process.env.NODE_ENV !== "production" && (Ot.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: v.node,
  /**
   * CSS class applied to the element, or a function that
   * returns a class based on the component’s state.
   */
  className: v.oneOfType([v.func, v.string]),
  /**
   * @ignore
   */
  itemRef: Tt,
  /**
   * @ignore
   */
  metadata: v.any,
  /**
   * Allows you to replace the component’s HTML element
   * with a different tag, or compose it with another component.
   *
   * Accepts a `ReactElement` or a function that returns the element to render.
   */
  render: v.oneOfType([v.element, v.func])
});
const Bn = {
  "data-starting-style": ""
}, Ln = {
  "data-ending-style": ""
}, Yn = {
  transitionStatus(e) {
    return e === "starting" ? Bn : e === "ending" ? Ln : null;
  }
}, St = {
  checked(e) {
    return e ? {
      "data-checked": ""
    } : {
      "data-unchecked": ""
    };
  },
  ...Yn,
  ...Et
}, xt = /* @__PURE__ */ y.forwardRef(function(t, o) {
  const {
    render: n,
    className: r,
    disabled: i = !1,
    readOnly: s = !1,
    required: l = !1,
    ...u
  } = t, {
    disabled: h,
    readOnly: c,
    required: a,
    setCheckedValue: d
  } = vt(), {
    state: g,
    disabled: C
  } = pe(), T = C || h || i, O = c || s, S = a || l, {
    getRootProps: D,
    getInputProps: I,
    checked: b
  } = Fn({
    ...t,
    disabled: T,
    readOnly: O
  }), m = y.useMemo(() => ({
    ...g,
    required: S,
    disabled: T,
    readOnly: O,
    checked: b
  }), [g, T, O, b, S]), L = y.useMemo(() => m, [m]), {
    renderElement: q
  } = ye({
    propGetter: D,
    render: n ?? "button",
    ref: o,
    className: r,
    state: m,
    extraProps: u,
    customStyleHookMapping: St
  });
  return /* @__PURE__ */ G(Be.Provider, {
    value: L,
    children: [d === Ce ? q() : /* @__PURE__ */ x(Ot, {
      render: q()
    }), /* @__PURE__ */ x("input", {
      ...I()
    })]
  });
});
process.env.NODE_ENV !== "production" && (xt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: v.node,
  /**
   * CSS class applied to the element, or a function that
   * returns a class based on the component’s state.
   */
  className: v.oneOfType([v.func, v.string]),
  /**
   * Whether the component should ignore user interaction.
   * @default false
   */
  disabled: v.bool,
  /**
   * Whether the user should be unable to select the radio button.
   * @default false
   */
  readOnly: v.bool,
  /**
   * Allows you to replace the component’s HTML element
   * with a different tag, or compose it with another component.
   *
   * Accepts a `ReactElement` or a function that returns the element to render.
   */
  render: v.oneOfType([v.element, v.func]),
  /**
   * Whether the user must choose a value before submitting a form.
   * @default false
   */
  required: v.bool,
  /**
   * The unique identifying value of the radio in a group.
   */
  value: v.any.isRequired
});
function fe(e) {
  const t = y.useRef(e);
  return ee(() => {
    t.current = e;
  }), y.useCallback((...o) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...o);
  }, []);
}
function Hn(e, t = !1) {
  const o = y.useRef(-1), n = y.useRef(-1), r = fe(() => {
    cancelAnimationFrame(o.current), clearTimeout(n.current);
  });
  return y.useEffect(() => r, [r]), fe((i) => {
    r();
    const s = e.current;
    s && (typeof s.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED ? i() : o.current = requestAnimationFrame(() => {
      function l() {
        s && Promise.allSettled(s.getAnimations().map((u) => u.finished)).then(() => {
          ct.flushSync(i);
        });
      }
      t ? n.current = window.setTimeout(l) : l();
    }));
  });
}
function Pt(e) {
  const t = y.useRef(e);
  return ee(() => {
    t.current = e;
  }), t;
}
function Wn(e) {
  const {
    open: t,
    ref: o,
    onComplete: n
  } = e, r = Pt(t), i = fe(n), s = Hn(o, t);
  ee(() => {
    s(() => {
      t === r.current && i();
    });
  }, [t, i, s, r]);
}
function Un(e, t = !1) {
  const [o, n] = y.useState(), [r, i] = y.useState(e);
  return e && !r && (i(!0), o !== "starting" && !t && n("starting")), !e && r && o !== "ending" && n("ending"), !e && !r && o === "ending" && n(void 0), ee(() => {
    if (!e)
      return;
    t && n("starting");
    const s = requestAnimationFrame(() => {
      n(void 0);
    });
    return () => {
      cancelAnimationFrame(s);
    };
  }, [e, t]), y.useMemo(() => ({
    mounted: r,
    setMounted: i,
    transitionStatus: o
  }), [r, o]);
}
const wt = /* @__PURE__ */ y.forwardRef(function(t, o) {
  const {
    render: n,
    className: r,
    keepMounted: i = !1,
    ...s
  } = t, l = Vn(), u = l.checked, {
    transitionStatus: h,
    setMounted: c
  } = Un(u), a = y.useMemo(() => ({
    ...l,
    transitionStatus: h
  }), [l, h]), d = y.useRef(null), g = Se(o, d), {
    renderElement: C
  } = ye({
    render: n ?? "span",
    ref: g,
    className: r,
    state: a,
    extraProps: s,
    customStyleHookMapping: St
  });
  return Wn({
    open: u,
    ref: d,
    onComplete() {
      u || c(!1);
    }
  }), i || u ? C() : null;
});
process.env.NODE_ENV !== "production" && (wt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: v.node,
  /**
   * CSS class applied to the element, or a function that
   * returns a class based on the component’s state.
   */
  className: v.oneOfType([v.func, v.string]),
  /**
   * Whether to keep the HTML element in the DOM when the radio button is inactive.
   * @default false
   */
  keepMounted: v.bool,
  /**
   * Allows you to replace the component’s HTML element
   * with a different tag, or compose it with another component.
   *
   * Accepts a `ReactElement` or a function that returns the element to render.
   */
  render: v.oneOfType([v.element, v.func])
});
const Gn = f.object({
  variants: f.custom().optional(),
  value: f.string().optional(),
  label: f.string().optional()
}), Kn = J(
  "RadioButton",
  X(
    {
      schema: Gn,
      defaultProps: {}
    },
    ({ value: e, label: t, variants: o }) => {
      const n = Xt.styles(o);
      return /* @__PURE__ */ G("label", { className: n.label, children: [
        /* @__PURE__ */ x(xt, { value: e, className: n.base, children: /* @__PURE__ */ x(wt, { className: n.indicator }) }),
        t
      ] });
    }
  )
), zn = Object.is;
function Jn(e, t) {
  if (e === t)
    return !0;
  if (!(e instanceof Object) || !(t instanceof Object))
    return !1;
  let o = 0, n = 0;
  for (const r in e)
    if (o += 1, !zn(e[r], t[r]) || !(r in t))
      return !1;
  for (const r in t)
    n += 1;
  return o === n;
}
function Xn(e, t) {
  const o = e.compareDocumentPosition(t);
  return o & Node.DOCUMENT_POSITION_FOLLOWING || o & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING || o & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
function Zn(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const [o, n] of e.entries()) {
    const r = t.get(o);
    if ((n == null ? void 0 : n.index) !== (r == null ? void 0 : r.index) || r !== void 0 && !Jn(n, r))
      return !1;
  }
  return !0;
}
function It(e) {
  const {
    children: t,
    elementsRef: o,
    labelsRef: n,
    onMapChange: r
  } = e, [i, s] = y.useState(() => /* @__PURE__ */ new Map()), l = y.useCallback((c, a) => {
    s((d) => new Map(d).set(c, a ?? null));
  }, []), u = y.useCallback((c) => {
    s((a) => {
      const d = new Map(a);
      return d.delete(c), d;
    });
  }, []);
  ee(() => {
    const c = new Map(i);
    Array.from(c.keys()).sort(Xn).forEach((d, g) => {
      const C = i.get(d) ?? {};
      c.set(d, {
        ...C,
        index: g
      });
    }), Zn(i, c) || (s(c), r == null || r(c));
  }, [i, r]);
  const h = y.useMemo(() => ({
    register: l,
    unregister: u,
    map: i,
    elementsRef: o,
    labelsRef: n
  }), [l, u, i, o, n]);
  return /* @__PURE__ */ x(Ye.Provider, {
    value: h,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (It.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: v.node,
  /**
   * A ref to the list of HTML elements, ordered by their index.
   * `useListNavigation`'s `listRef` prop.
   */
  elementsRef: v.any,
  /**
   * A ref to the list of element labels, ordered by their index.
   * `useTypeahead`'s `listRef` prop.
   */
  labelsRef: v.shape({
    current: v.arrayOf(v.string).isRequired
  }),
  /**
   * @ignore
   */
  onMapChange: v.func
});
let De = null, ke;
function Qn() {
  return De == null && (De = document.createElement("div")), ke === void 0 && (ke = De.computedStyleMap !== void 0), ke;
}
function er(e) {
  return e && e.ownerDocument || document;
}
function tr(e) {
  return er(e).defaultView || window;
}
const he = "ArrowUp", le = "ArrowDown", de = "ArrowLeft", se = "ArrowRight", xe = "Home", Pe = "End", _t = [de, se], nr = [de, se, xe, Pe], Nt = [he, le], rr = [he, le, xe, Pe], Mt = [..._t, ...Nt], or = [...Mt, xe, Pe];
function be(e) {
  e.preventDefault(), e.stopPropagation();
}
function Ee(e, t, o) {
  return Math.floor(e / t) !== o;
}
function Re(e, t) {
  return t < 0 || t >= e.current.length;
}
function ir(e, t) {
  return W(e, {
    disabledIndices: t
  });
}
function ar(e, t) {
  return W(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function W(e, {
  startingIndex: t = -1,
  decrement: o = !1,
  disabledIndices: n,
  amount: r = 1
} = {}) {
  const i = e.current;
  let s = t;
  do
    s += o ? -r : r;
  while (s >= 0 && s <= i.length - 1 && Te(i, s, n));
  return s;
}
function sr(e, {
  event: t,
  orientation: o,
  loop: n,
  cols: r,
  disabledIndices: i,
  minIndex: s,
  maxIndex: l,
  prevIndex: u,
  rtl: h,
  stopEvent: c = !1
}) {
  let a = u;
  if (t.key === he) {
    if (c && be(t), u === -1)
      a = l;
    else if (a = W(e, {
      startingIndex: a,
      amount: r,
      decrement: !0,
      disabledIndices: i
    }), n && (u - r < s || a < 0)) {
      const d = u % r, g = l % r, C = l - (g - d);
      g === d ? a = l : a = g > d ? C : C - r;
    }
    Re(e, a) && (a = u);
  }
  if (t.key === le && (c && be(t), u === -1 ? a = s : (a = W(e, {
    startingIndex: u,
    amount: r,
    disabledIndices: i
  }), n && u + r > l && (a = W(e, {
    startingIndex: u % r - r,
    amount: r,
    disabledIndices: i
  }))), Re(e, a) && (a = u)), o === "both") {
    const d = h ? de : se, g = h ? se : de, C = Math.floor(u / r);
    t.key === d && (c && be(t), u % r !== r - 1 ? (a = W(e, {
      startingIndex: u,
      disabledIndices: i
    }), n && Ee(a, r, C) && (a = W(e, {
      startingIndex: u - u % r - 1,
      disabledIndices: i
    }))) : n && (a = W(e, {
      startingIndex: u - u % r - 1,
      disabledIndices: i
    })), Ee(a, r, C) && (a = u)), t.key === g && (c && be(t), u % r !== 0 ? (a = W(e, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: i
    }), n && Ee(a, r, C) && (a = W(e, {
      startingIndex: u + (r - u % r),
      decrement: !0,
      disabledIndices: i
    }))) : n && (a = W(e, {
      startingIndex: u + (r - u % r),
      decrement: !0,
      disabledIndices: i
    })), Ee(a, r, C) && (a = u));
    const T = Math.floor(l / r) === C;
    Re(e, a) && (n && T ? a = t.key === g ? l : W(e, {
      startingIndex: u - u % r - 1,
      disabledIndices: i
    }) : a = u);
  }
  return a;
}
function ur(e, t, o) {
  const n = [];
  let r = 0;
  return e.forEach(({
    width: i,
    height: s
  }, l) => {
    if (i > t && process.env.NODE_ENV !== "production")
      throw new Error(`[Base UI]: Invalid grid - item width at index ${l} is greater than grid columns`);
    let u = !1;
    for (o && (r = 0); !u; ) {
      const h = [];
      for (let c = 0; c < i; c += 1)
        for (let a = 0; a < s; a += 1)
          h.push(r + c + a * t);
      r % t + i <= t && h.every((c) => n[c] == null) ? (h.forEach((c) => {
        n[c] = l;
      }), u = !0) : r += 1;
    }
  }), [...n];
}
function cr(e, t, o, n, r) {
  if (e === -1)
    return -1;
  const i = o.indexOf(e), s = t[e];
  switch (r) {
    case "tl":
      return i;
    case "tr":
      return s ? i + s.width - 1 : i;
    case "bl":
      return s ? i + (s.height - 1) * n : i;
    case "br":
      return o.lastIndexOf(e);
    default:
      return -1;
  }
}
function lr(e, t) {
  return t.flatMap((o, n) => e.includes(o) ? [n] : []);
}
function Te(e, t, o) {
  if (o)
    return o.includes(t);
  const n = e[t];
  return n == null || n.hasAttribute("disabled") || n.getAttribute("aria-disabled") === "true";
}
function fr(e) {
  if (Qn()) {
    const t = e.computedStyleMap().get("direction");
    return t == null ? void 0 : t.value;
  }
  return tr(e).getComputedStyle(e).direction;
}
const me = void 0;
function dr(e) {
  const {
    itemSizes: t,
    cols: o = 1,
    loop: n = !0,
    dense: r = !1,
    orientation: i = "both",
    direction: s,
    highlightedIndex: l,
    onHighlightedIndexChange: u,
    rootRef: h,
    enableHomeAndEndKeys: c = !1,
    stopEventPropagation: a = !1
  } = e, [d, g] = y.useState(0), C = o > 1, T = l ?? d, O = fe(u ?? g), S = y.useRef(s ?? null), D = y.useRef(null), I = Se(D, h), b = y.useRef([]), m = y.useCallback((L = {}) => oe(L, {
    "aria-orientation": i === "both" ? void 0 : i,
    ref: I,
    onKeyDown(q) {
      const Z = c ? or : Mt;
      if (!Z.includes(q.key))
        return;
      const U = D.current;
      if (!U)
        return;
      (S == null ? void 0 : S.current) == null && (S.current = fr(U));
      const K = S.current === "rtl";
      let B = T;
      const ie = ir(b, me), ae = ar(b, me);
      if (C) {
        const ne = t || Array.from({
          length: b.current.length
        }, () => ({
          width: 1,
          height: 1
        })), p = ur(ne, o, r), R = p.findIndex((w) => w != null && !Te(b.current, w, me)), _ = p.reduce((w, P, A) => P != null && !Te(b.current, P, me) ? A : w, -1);
        B = p[sr({
          current: p.map((w) => w ? b.current[w] : null)
        }, {
          event: q,
          orientation: i,
          loop: n,
          cols: o,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: lr([...b.current.map((w, P) => Te(b.current, P) ? P : void 0), void 0], p),
          minIndex: R,
          maxIndex: _,
          prevIndex: cr(
            T > ae ? ie : T,
            ne,
            p,
            o,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            q.key === le ? "bl" : q.key === se ? "tr" : "tl"
          ),
          rtl: K
        })];
      }
      const te = K ? de : se, ue = {
        horizontal: [te],
        vertical: [le],
        both: [te, le]
      }[i], H = K ? se : de, z = {
        horizontal: [H],
        vertical: [he],
        both: [H, he]
      }[i], ce = C ? Z : {
        horizontal: c ? nr : _t,
        vertical: c ? rr : Nt,
        both: Z
      }[i];
      c && (q.key === xe ? B = ie : q.key === Pe && (B = ae)), B === T && [...ue, ...z].includes(q.key) && (n && B === ae && ue.includes(q.key) ? B = ie : n && B === ie && z.includes(q.key) ? B = ae : B = W(b, {
        startingIndex: B,
        decrement: z.includes(q.key),
        disabledIndices: me
      })), B !== T && !Re(b, B) && (a && q.stopPropagation(), ce.includes(q.key) && q.preventDefault(), O(B), queueMicrotask(() => {
        var ne;
        (ne = b.current[B]) == null || ne.focus();
      }));
    }
  }), [T, a, o, r, b, C, t, n, I, O, i, c]);
  return y.useMemo(() => ({
    getRootProps: m,
    highlightedIndex: T,
    onHighlightedIndexChange: O,
    elementsRef: b
  }), [m, T, O, b]);
}
function At(e) {
  const {
    render: t,
    className: o,
    highlightedIndex: n,
    onHighlightedIndexChange: r,
    orientation: i,
    dense: s,
    itemSizes: l,
    loop: u,
    cols: h,
    direction: c,
    enableHomeAndEndKeys: a,
    onMapChange: d,
    stopEventPropagation: g,
    rootRef: C,
    ...T
  } = e, {
    getRootProps: O,
    highlightedIndex: S,
    onHighlightedIndexChange: D,
    elementsRef: I
  } = dr({
    itemSizes: l,
    cols: h,
    loop: u,
    dense: s,
    orientation: i,
    highlightedIndex: n,
    onHighlightedIndexChange: r,
    rootRef: C,
    stopEventPropagation: g,
    enableHomeAndEndKeys: a,
    direction: c
  }), {
    renderElement: b
  } = ye({
    propGetter: O,
    render: t ?? "div",
    state: {},
    className: o,
    extraProps: T
  }), m = y.useMemo(() => ({
    highlightedIndex: S,
    onHighlightedIndexChange: D
  }), [S, D]);
  return /* @__PURE__ */ x(Le.Provider, {
    value: m,
    children: /* @__PURE__ */ x(It, {
      elementsRef: I,
      onMapChange: d,
      children: b()
    })
  });
}
process.env.NODE_ENV !== "production" && (At.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: v.node,
  /**
   * CSS class applied to the element, or a function that
   * returns a class based on the component’s state.
   */
  className: v.oneOfType([v.func, v.string]),
  /**
   * @ignore
   */
  cols: v.number,
  /**
   * @ignore
   */
  dense: v.bool,
  /**
   * @ignore
   */
  direction: v.oneOf(["ltr", "rtl"]),
  /**
   * @ignore
   */
  enableHomeAndEndKeys: v.bool,
  /**
   * @ignore
   */
  highlightedIndex: v.number,
  /**
   * @ignore
   */
  itemSizes: v.arrayOf(v.shape({
    height: v.number.isRequired,
    width: v.number.isRequired
  })),
  /**
   * @ignore
   */
  loop: v.bool,
  /**
   * @ignore
   */
  onHighlightedIndexChange: v.func,
  /**
   * @ignore
   */
  onMapChange: v.func,
  /**
   * @ignore
   */
  orientation: v.oneOf(["both", "horizontal", "vertical"]),
  /**
   * Allows you to replace the component’s HTML element
   * with a different tag, or compose it with another component.
   *
   * Accepts a `ReactElement` or a function that returns the element to render.
   */
  render: v.oneOfType([v.element, v.func]),
  /**
   * @ignore
   */
  rootRef: Tt,
  /**
   * @ignore
   */
  stopEventPropagation: v.bool
});
const Dt = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (Dt.displayName = "DirectionContext");
function pr(e = !0) {
  const t = y.useContext(Dt);
  if (t === void 0 && !e)
    throw new Error("Base UI: DirectionContext is missing.");
  return (t == null ? void 0 : t.direction) ?? "ltr";
}
function mr() {
  return typeof window < "u";
}
function hr(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function yr(e) {
  return !mr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof hr(e).ShadowRoot;
}
function gr(e, t) {
  if (!e || !t)
    return !1;
  const o = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (o && yr(o)) {
    let n = t;
    for (; n; ) {
      if (e === n)
        return !0;
      n = n.parentNode || n.host;
    }
  }
  return !1;
}
function vr({
  controlled: e,
  default: t,
  name: o,
  state: n = "value"
}) {
  const {
    current: r
  } = y.useRef(e !== void 0), [i, s] = y.useState(t), l = r ? e : i;
  if (process.env.NODE_ENV !== "production") {
    y.useEffect(() => {
      r !== (e !== void 0) && console.error([`Base UI: A component is changing the ${r ? "" : "un"}controlled ${n} state of ${o} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${o} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [n, o, e]);
    const {
      current: h
    } = y.useRef(t);
    y.useEffect(() => {
      !r && !Object.is(h, t) && console.error([`Base UI: A component is changing the default ${n} state of an uncontrolled ${o} after being initialized. To suppress this warning opt to use a controlled ${o}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const u = y.useCallback((h) => {
    r || s(h);
  }, []);
  return [l, u];
}
let nt = 0;
function br(e, t = "mui") {
  const [o, n] = y.useState(e), r = e || o;
  return y.useEffect(() => {
    o == null && (nt += 1, n(`${t}-${nt}`));
  }, [o, t]), r;
}
const Er = {
  ...y
}, rt = Er.useId;
function Cr(e, t) {
  if (rt !== void 0) {
    const o = rt();
    return e ?? (t ? `${t}-${o}` : o);
  }
  return br(e, t);
}
function Rr(e) {
  return Cr(e, "base-ui");
}
const kt = /* @__PURE__ */ y.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  onClearErrors: () => {
  }
});
process.env.NODE_ENV !== "production" && (kt.displayName = "FormContext");
function Ft() {
  return y.useContext(kt);
}
function Vt(e, t) {
  return {
    ...e,
    state: {
      ...e.state,
      valid: !t && e.state.valid
    }
  };
}
const Tr = Object.keys(bt);
function Or() {
  const {
    setValidityData: e,
    validate: t,
    messageIds: o,
    validityData: n,
    validationMode: r,
    validationDebounceTime: i,
    invalid: s,
    markedDirtyRef: l,
    controlId: u,
    state: h
  } = pe(), {
    formRef: c
  } = Ft(), a = y.useRef(-1), d = y.useRef(null);
  y.useEffect(() => () => {
    window.clearTimeout(a.current);
  }, []);
  const g = fe(async (O) => {
    const S = d.current;
    if (!S)
      return;
    function D(U) {
      return Tr.reduce((K, B) => (K[B] = U.validity[B], !U.validity.customError && !l.current && (K[B] = B === "valid"), K), {});
    }
    window.clearTimeout(a.current);
    const I = t(O);
    let b = null;
    typeof I == "object" && I !== null && "then" in I ? b = await I : b = I;
    let m = "";
    b !== null && (m = Array.isArray(b) ? b.join(`
`) : b), S.setCustomValidity(m);
    const L = D(S);
    let q = [];
    Array.isArray(b) ? q = b : b ? q = [b] : S.validationMessage && (q = [S.validationMessage]);
    const Z = {
      value: O,
      state: L,
      error: Array.isArray(b) ? b[0] : b ?? S.validationMessage,
      errors: q,
      initialValue: n.initialValue
    };
    if (u) {
      const U = c.current.fields.get(u);
      U && c.current.fields.set(u, {
        ...U,
        ...Vt(Z, s)
      });
    }
    e(Z);
  }), C = y.useCallback((O = {}) => oe(O, {
    ...o.length && {
      "aria-describedby": o.join(" ")
    },
    ...h.valid === !1 && {
      "aria-invalid": !0
    }
  }), [o, h.valid]), T = y.useCallback((O = {}) => oe(C(O), {
    onChange(S) {
      if (S.nativeEvent.defaultPrevented || s || r !== "onChange")
        return;
      const D = S.currentTarget;
      if (D.value === "") {
        g(D.value);
        return;
      }
      window.clearTimeout(a.current), i ? a.current = window.setTimeout(() => {
        g(D.value);
      }, i) : g(D.value);
    }
  }), [C, s, r, i, g]);
  return y.useMemo(() => ({
    getValidationProps: C,
    getInputValidationProps: T,
    inputRef: d,
    commitValidation: g
  }), [C, T, g]);
}
function Sr(e) {
  const {
    formRef: t
  } = Ft(), {
    invalid: o,
    markedDirtyRef: n,
    validityData: r,
    setValidityData: i
  } = pe(), {
    value: s,
    id: l,
    controlRef: u,
    commitValidation: h
  } = e, c = Pt(e.getValue);
  ee(() => {
    var d;
    let a = s;
    a === void 0 && (a = (d = c.current) == null ? void 0 : d.call(c)), r.initialValue === null && a !== r.initialValue && i((g) => ({
      ...g,
      initialValue: a
    }));
  }, [i, s, r.initialValue, c]), ee(() => {
    l && t.current.fields.set(l, {
      controlRef: u,
      validityData: Vt(r, o),
      validate() {
        var d;
        let a = s;
        a === void 0 && (a = (d = c.current) == null ? void 0 : d.call(c)), n.current = !0, ct.flushSync(() => h(a));
      }
    });
  }, [h, u, t, c, l, o, n, r, s]);
}
function xr(e) {
  const {
    disabled: t = !1,
    name: o,
    defaultValue: n,
    readOnly: r,
    value: i
  } = e, {
    labelId: s,
    setTouched: l,
    setFocused: u,
    validationMode: h
  } = pe(), c = Or(), a = Rr(), [d, g] = vr({
    controlled: i,
    default: n,
    name: "RadioGroup",
    state: "value"
  });
  Sr({
    id: a,
    commitValidation: c.commitValidation,
    value: d,
    controlRef: c.inputRef
  });
  const [C, T] = y.useState(!1), O = y.useCallback((I = {}) => oe(c.getValidationProps(I), {
    role: "radiogroup",
    "aria-disabled": t || void 0,
    "aria-readonly": r || void 0,
    "aria-labelledby": s,
    onFocus() {
      u(!0);
    },
    onBlur(b) {
      gr(b.currentTarget, b.relatedTarget) || (l(!0), u(!1), h === "onBlur" && c.commitValidation(d));
    },
    onKeyDownCapture(b) {
      b.key.startsWith("Arrow") && (l(!0), T(!0), u(!0));
    }
  }), [c, t, r, s, u, l, h, d]), S = y.useMemo(() => d == null ? "" : typeof d == "string" ? d : JSON.stringify(d), [d]), D = y.useCallback((I = {}) => oe(c.getInputValidationProps(I), {
    type: "hidden",
    value: S,
    ref: c.inputRef,
    id: a,
    name: o,
    disabled: t,
    readOnly: r
  }), [c, S, a, o, t, r]);
  return y.useMemo(() => ({
    getRootProps: O,
    getInputProps: D,
    checkedValue: d,
    setCheckedValue: g,
    touched: C,
    setTouched: T,
    fieldControlValidation: c
  }), [O, D, d, g, C, c]);
}
const jt = /* @__PURE__ */ y.forwardRef(function(t, o) {
  const {
    render: n,
    className: r,
    disabled: i,
    readOnly: s,
    required: l,
    onValueChange: u,
    name: h,
    ...c
  } = t, a = pr(), d = xr(t), {
    state: g,
    disabled: C
  } = pe(), T = C || i, O = fe(u ?? (() => {
  })), S = y.useMemo(() => ({
    ...g,
    disabled: T ?? !1,
    required: l ?? !1,
    readOnly: s ?? !1
  }), [g, T, s, l]), D = y.useMemo(() => ({
    ...g,
    ...d,
    onValueChange: O,
    disabled: T,
    readOnly: s,
    required: l
  }), [g, T, O, d, s, l]), {
    renderElement: I
  } = ye({
    propGetter: d.getRootProps,
    render: n ?? "div",
    ref: o,
    className: r,
    state: S,
    extraProps: c,
    customStyleHookMapping: Et
  });
  return /* @__PURE__ */ G(qe.Provider, {
    value: D,
    children: [/* @__PURE__ */ x(At, {
      direction: a,
      enableHomeAndEndKeys: !1,
      render: I()
    }), /* @__PURE__ */ x("input", {
      ...d.getInputProps()
    })]
  });
});
process.env.NODE_ENV !== "production" && (jt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: v.node,
  /**
   * CSS class applied to the element, or a function that
   * returns a class based on the component’s state.
   */
  className: v.oneOfType([v.func, v.string]),
  /**
   * The uncontrolled value of the radio button that should be initially selected.
   *
   * To render a controlled radio group, use the `value` prop instead.
   */
  defaultValue: v.any,
  /**
   * Whether the component should ignore user interaction.
   * @default false
   */
  disabled: v.bool,
  /**
   * Identifies the field when a form is submitted.
   */
  name: v.string,
  /**
   * Callback fired when the value changes.
   */
  onValueChange: v.func,
  /**
   * Whether the user should be unable to select a different radio button in the group.
   * @default false
   */
  readOnly: v.bool,
  /**
   * Allows you to replace the component’s HTML element
   * with a different tag, or compose it with another component.
   *
   * Accepts a `ReactElement` or a function that returns the element to render.
   */
  render: v.oneOfType([v.element, v.func]),
  /**
   * Whether the user must choose a value before submitting a form.
   * @default false
   */
  required: v.bool,
  /**
   * The controlled value of the radio item that should be currently selected.
   *
   * To render an uncontrolled radio group, use the `defaultValue` prop instead.
   */
  value: v.any
});
const Pr = f.object({
  variants: f.custom().optional(),
  value: f.string().optional(),
  onValueChange: f.function().args(f.unknown(), f.instanceof(Event)).returns(f.void()).optional(),
  children: f.any()
}), wr = J(
  "RadioGroup",
  X(
    {
      schema: Pr,
      defaultProps: {}
    },
    ({ value: e, children: t, variants: o, onValueChange: n }) => {
      const r = Zt.styles(o);
      return /* @__PURE__ */ x(
        jt,
        {
          className: r.base,
          value: e,
          onValueChange: n,
          children: t
        }
      );
    }
  )
), Jr = {
  RadioButton: Kn,
  RadioGroup: wr
}, Ir = f.object({
  variants: f.custom().optional(),
  children: f.custom().optional(),
  defaultValue: f.string().optional(),
  placeholder: f.string().optional(),
  checkIcon: f.custom().optional(),
  listBoxButtonSettings: f.custom().optional(),
  arrowIcon: f.custom().optional(),
  // Use the as prop to decide which rendering to use.
  as: f.literal("select").or(f.literal("button")).optional(),
  label: f.union([f.string(), f.literal(!1)]).optional(),
  onChange: f.custom().optional(),
  value: f.custom().optional()
}), Xr = J(
  "SelectBox",
  X(
    {
      schema: Ir,
      defaultProps: {
        checkIcon: /* @__PURE__ */ x(ut, {}),
        arrowIcon: /* @__PURE__ */ x(an, {}),
        onChange: () => {
        },
        as: "select",
        label: !1
      }
    },
    ({
      variants: e,
      defaultValue: t,
      placeholder: o,
      label: n,
      children: r,
      checkIcon: i,
      arrowIcon: s,
      listBoxButtonSettings: l,
      as: u,
      onChange: h,
      value: c
    }) => {
      const a = it.styles(e), d = je(), g = Lt(
        () => Yt.map(r, (C, T) => Ht(C) ? /* @__PURE__ */ Wt(
          Nr,
          {
            ...C.props,
            variants: e,
            checkIcon: i,
            key: `${T}-${C.props.value}`,
            className: a.listBoxOption
          }
        ) : C),
        [r, c, i, e, a.listBoxOption]
      );
      return /* @__PURE__ */ G(at, { className: a.base, children: [
        n && /* @__PURE__ */ x(st, { className: a.fieldLabel, children: d(n) }),
        /* @__PURE__ */ G(
          en,
          {
            defaultValue: t,
            value: c,
            onChange: h,
            children: [
              /* @__PURE__ */ G(
                tn,
                {
                  className: a.listBoxButton,
                  ...l,
                  children: [
                    !c && !t && o,
                    /* @__PURE__ */ x(
                      nn,
                      {
                        options: r,
                        placeholder: o
                      }
                    ),
                    /* @__PURE__ */ x("span", { className: a.listBoxArrow, children: s })
                  ]
                }
              ),
              u === "select" && /* @__PURE__ */ x(
                rn,
                {
                  transition: !0,
                  modal: !1,
                  className: a.listBoxOptions,
                  children: g
                }
              )
            ]
          }
        )
      ] });
    }
  )
), _r = f.object({
  variants: f.custom().optional(),
  value: f.string(),
  selectedValue: f.string().optional(),
  onSelect: f.function().args(
    f.object({
      value: f.string(),
      label: f.string().optional(),
      icon: f.custom().optional()
    })
  ).returns(f.void()).optional(),
  label: f.string().optional(),
  icon: f.custom().optional(),
  checkIcon: f.custom().optional(),
  className: f.string().optional()
}), Nr = J(
  "SelectBoxItem",
  X(
    _r,
    ({ variants: e, value: t, label: o, icon: n, selectedValue: r, className: i, checkIcon: s }) => {
      const l = it.styles(e), u = r === t;
      return /* @__PURE__ */ G(on, { value: t, className: i, children: [
        /* @__PURE__ */ G("div", { className: "flex items-center", children: [
          n && /* @__PURE__ */ x("span", { className: l.listBoxIcon, children: n }),
          o && /* @__PURE__ */ x("span", { className: l.listBoxLabel, children: o })
        ] }),
        u && /* @__PURE__ */ x("span", { className: l.listBoxCheck, children: s })
      ] });
    }
  )
);
export {
  Wr as Checkbox,
  Ur as Form,
  Gr as FormGroup,
  ln as FormProvider,
  Kr as InputField,
  pn as InputFieldDefault,
  mn as InputFieldFloatingLabel,
  zr as PhoneNumberField,
  Jr as Radio,
  Kn as RadioButton,
  wr as RadioGroup,
  Xr as SelectBox,
  Nr as SelectBoxItem,
  cn as checkboxSchema,
  dn as formGroupSchema,
  fn as formSchema,
  pt as inputFieldDefaultSchema,
  mt as inputFieldFloatingLabelSchema,
  hn as inputFieldSchema,
  dt as inputFieldSharedSchema,
  yn as phoneNumberFieldSchema,
  Gn as radioButtonSchema,
  Pr as radioGroupSchema,
  _r as selectBoxItemSchema,
  Ir as selectBoxSchema,
  ft as useForm
};
//# sourceMappingURL=index.es.js.map
